import { render } from "./BookingSideBar.vue?vue&type=template&id=505920ee&scoped=true"
import script from "./BookingSideBar.vue?vue&type=script&lang=js"
export * from "./BookingSideBar.vue?vue&type=script&lang=js"

import "./BookingSideBar.vue?vue&type=style&index=0&id=505920ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505920ee"]])

export default __exports__